import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class TradePaymentUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.tradePayment(req);
    }
}
export default TradePaymentUseCase;
